


















import { Prop, Component, Vue } from 'vue-property-decorator';
import {
  Badge,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tooltip
} from 'element-ui';

// gql
import fetchNotificationsQuery from '@/graphql/queries/FetchNotifications.gql';
import readNotifications from '@/graphql/mutations/ReadNotifications.gql';
import appEventNotification from '@/graphql/subscriptions/AppEventNotification.gql';

import { NotificationFields, NotificationStatusEnum } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    notifications: {
      query: fetchNotificationsQuery,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          notificationArgs: {
            language: this.$i18n.locale || 'ja'
          },
          pagination: {
            page: 1,
            per: 5
          }
        };
      },
      update(data) {
        this.initialized = true;
        return data?.notifications;
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    },
    $subscribe: {
      appEventNotifications: {
        query: appEventNotification,
        result({ data }) {
          if (data?.eventNotification.eventName === 'notification_created') {
            this.$store.commit('User/setUnreadNotification', true, { root: true });
            // notification payload is null... -> retech
            this.$apollo.queries.notifications.refetch();
          }
        }
      }
    }
  },
  components: {
    'el-badge': Badge,
    'el-button': Button,
    'el-dropdown': Dropdown,
    'el-dropdown-item': DropdownItem,
    'el-dropdown-menu': DropdownMenu
  }
})
export default class Notifications extends Vue {
  initialized = false;
  notifications: NotificationFields[] = [];

  readonly NotificationStatusEnum = NotificationStatusEnum;

  get hasUnreadNotification() {
    return !this.$store.state.User.hasUnreadNotifications;
  }

  handleCommand(commande: NotificationFields | string) {
    if (typeof commande === 'string' && commande === 'all') {
      this.$router.push({ name: 'notifications' });
    } else {
      const notification: NotificationFields = commande as NotificationFields;

      switch (notification.notificationType) {
        case 'vessel_delayed':
          this.$router.push({
            name: 'shipmentActivities',
            params: { id: notification.subject.shipmentId }
          });
          break;
        case 'new_inquiry':
          this.$router.push({
            name: 'inquiryQuote',
            params: { id: notification.subject.shipmentId || '' }
          });
          break;

        case 'quote_accepted':
          this.$router.push({
            name: 'shipmentActivities',
            params: { id: notification.subject.shipmentId || '' }
          });
          break;

        case 'message_added':
        case 'private_message_added':
        case 'message_file_added':
          if (notification.subject.shipmentStatus === 'shipment') {
            this.$router.push({
              name: 'shipmentChannels',
              params: { id: notification.subject.shipmentId || '' }
            });
          } else {
            this.$router.push({
              name: 'inquiryChannels',
              params: { id: notification.subject.shipmentId || '' }
            });
          }
          break;

        case 'file_added':
        case 'private_file_added':
          if (notification.subject.shipmentStatus === 'shipment') {
            this.$router.push({
              name: 'shipmentAttachments',
              params: { id: notification.subject.shipmentId || '' }
            });
          } else {
            this.$router.push({
              name: 'inquiryAttachments',
              params: { id: notification.subject.shipmentId || '' }
            });
          }
          break;

        case 'bill_due':
          this.$router.push({
            name: 'bills'
          });
          break;

        case 'bill_paid':
          this.$router.push({
            name: 'bills'
          });
          break;
      }
    }
  }

  isUnread(notification: NotificationFields) {
    return notification.status === NotificationStatusEnum.unread;
  }

  async readNotifications() {
    const response = await this.$apollo.mutate({
      mutation: readNotifications
    });

    if (response) {
      this.$store.commit('User/readNotifications');
    }
  }
}
